module.exports = __webpack_public_path__ + "static/media/probuddyThumbnail-twitter-600X314.f85ff106.png";